import React from 'react'
import { useParams } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Star, MessageCircle, ThumbsUp } from 'lucide-react'

const ReviewDetailPage: React.FC = () => {
  const { id } = useParams()
  const [likes, setLikes] = React.useState(128)
  const [comments, setComments] = React.useState<Array<{ id: number; author: string; text: string }>>([
    { id: 1, author: 'Alex', text: 'Great write-up. Totally agree on the low-mid presence!' },
    { id: 2, author: 'Jamie', text: 'I compared with my SM57 — this one cuts better live.' },
  ])
  const [text, setText] = React.useState('')

  return (
    <div className="pt-16 lg:pt-20 min-h-screen">
      <section className="section-padding py-12">
        <div className="container-max max-w-4xl mx-auto">
          <motion.h1 className="text-4xl font-display font-bold text-white mb-3" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>Review #{id}</motion.h1>
          <p className="text-white/70 mb-6">In-depth review and community discussion.</p>

          <div className="glass-card overflow-hidden">
            <img src="https://images.pexels.com/photos/164938/pexels-photo-164938.jpeg?auto=compress&cs=tinysrgb&w=1200" alt="hero" className="w-full h-64 object-cover" />
            <div className="p-6">
              <div className="flex items-center justify-between text-white/80 text-sm mb-4">
                <div className="flex items-center gap-2"><Star size={16} className="text-yellow-400" /><span>4.8</span></div>
                <div className="flex items-center gap-4">
                  <button className="flex items-center gap-1 text-white/80 hover:text-white" onClick={() => setLikes((v) => v + 1)}><ThumbsUp size={16} /> <span>{likes}</span></button>
                  <div className="flex items-center gap-1"><MessageCircle size={16} /> <span>{comments.length}</span></div>
                </div>
              </div>
              <h2 className="text-2xl font-display font-semibold text-white mb-3">Shure SM58 — The Workhorse Mic</h2>
              <p className="text-white/80 leading-relaxed">
                The SM58 continues to be a live sound staple — rugged, reliable, and forgiving. In this review we measure tonal response,
                stage feedback behavior, and proximity effect. We also compare it against popular alternatives and share use-cases.
              </p>
            </div>
          </div>

          {/* Comments */}
          <div className="mt-8 glass-card p-6">
            <h3 className="text-white font-semibold mb-4">Comments</h3>
            <ul className="space-y-4 mb-4">
              {comments.map((c) => (
                <li key={c.id} className="bg-white/5 rounded-xl p-4">
                  <div className="text-white/80 text-sm mb-1">{c.author}</div>
                  <div className="text-white/90">{c.text}</div>
                </li>
              ))}
            </ul>
            <form
              onSubmit={(e) => {
                e.preventDefault()
                if (!text.trim()) return
                setComments((prev) => [...prev, { id: Date.now(), author: 'You', text }])
                setText('')
              }}
              className="flex gap-3"
            >
              <input
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="Share your take…"
                className="flex-1 bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/40 focus:outline-none focus:border-le-accent"
              />
              <button className="btn-primary px-6">Post</button>
            </form>
          </div>
        </div>
      </section>
    </div>
  )
}

export default ReviewDetailPage


